import { api, type GroceryListResponse } from './api';
import { ShoppingStore, type SavedShopping, type ShoppingPersistence } from './shopping-state';
const prefix = 'fmp-shopping-v1:';
const persistence: ShoppingPersistence = {
  load: (path) => {
    try {
      const raw = window.localStorage.getItem(prefix + path);
      if (!raw) return null;
      const saved = JSON.parse(raw) as SavedShopping;
      if (!saved || !Array.isArray(saved.edits) || typeof saved.savedAt !== 'number') return null;
      if (!saved.edits.length && Date.now() - saved.savedAt > 14 * 86400000) {
        window.localStorage.removeItem(prefix + path);
        return null;
      }
      return saved;
    } catch { return null; }
  },
  save: (path, state) => {
    if (!state.data && !state.edits.length) window.localStorage.removeItem(prefix + path);
    else window.localStorage.setItem(prefix + path, JSON.stringify(state));
  },
  clear: (path) => window.localStorage.removeItem(prefix + path),
};
const stores = new Map<string, ShoppingStore>();
export function shoppingStore(listId: string | null): ShoppingStore {
  const path = listId ? `/lists/${listId}` : '/lists/current';
  let store = stores.get(path);
  if (!store && listId) {
    store = [...stores.values()].find(candidate => candidate.snapshot().data?.list?.id === listId);
    if (store) { store.pin(listId); stores.set(path, store); }
  }
  if (!store) {
    store = new ShoppingStore(path, {
      read: (path, etag) => api.conditional<GroceryListResponse>(path, etag),
      write: (list, item, change) => api.patch(`/lists/${list}/items/${item}`, change),
    }, persistence);
    stores.set(path, store);
    store.subscribe(() => window.dispatchEvent(new Event('shopping-save-state')));
  }
  return store;
}

export function pendingShoppingChanges(): number {
  return [...new Set(stores.values())].reduce((count, store) => count + store.snapshot().pending, 0);
}
